<div class="modal fade" id="dialogAditamento" tabindex="-1" role="dialog" aria-labelledby="Aditamento"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header bg-primary text-white">
        <h5 class="modal-title" id="title">Aditamento de Convênio</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" *ngIf="entidade">
        <div class="form-row">
          <div class="form-group col-md-6">
            <label for="unidade">Data Assinatura<span class="text-danger">*</span></label>
            <p-calendar id="data_aditamento" [(ngModel)]="entidade.data_aditamento" inputStyleClass="form-control"
              dataType="date" dateFormat="dd/mm/yy" [locale]="ptBR" [showIcon]="true" class="ui-calendar-small"
              [showOnFocus]="false" [showButtonBar]="true" [style]="{ width: '100%' }">
            </p-calendar>
          </div>
          <div class="form-group col-md-6">
            <label for="unidade">Data Contabilização<span class="text-danger">*</span></label>
            <p-calendar id="data_contabilizacao" [(ngModel)]="entidade.data_contabilizacao"
              inputStyleClass="form-control" dataType="date" dateFormat="dd/mm/yy" [locale]="ptBR" [showIcon]="true"
              class="ui-calendar-small" [showOnFocus]="false" [showButtonBar]="true" [style]="{ width: '100%' }">
            </p-calendar>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group col-md-6">
            <label for="unidade">Data Início<span class="text-danger">*</span></label>
            <p-calendar id="data_inicio" [(ngModel)]="entidade.data_inicio" inputStyleClass="form-control"
              dataType="date" dateFormat="dd/mm/yy" [locale]="ptBR" [showIcon]="true" class="ui-calendar-small"
              [showOnFocus]="false" [showButtonBar]="true" [style]="{ width: '100%' }">
            </p-calendar>
          </div>
          <div class="form-group col-md-6">
            <label for="unidade">Data Término<span class="text-danger">*</span></label>
            <p-calendar id="data_termino" [(ngModel)]="entidade.data_termino" inputStyleClass="form-control"
              dataType="date" dateFormat="dd/mm/yy" [locale]="ptBR" [showIcon]="true" class="ui-calendar-small"
              [showOnFocus]="false" [showButtonBar]="true" [style]="{ width: '100%' }">
            </p-calendar>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group col-md-6">
            <label for="unidade">Finalidade<span class="text-danger">*</span></label>
            <select [compareWith]="compareFn" id="finalidade" [(ngModel)]="entidade.finalidade" class="custom-select">
              <option [ngValue]="item.id" *ngFor="let item of listaFinalidade">
                {{item.nome}}
              </option>
            </select>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-md-12">
            <label for="unidade">Descrição<span class="text-danger">*</span></label>
            <input [(ngModel)]="entidade.descricao" [ngModelOptions]="{standalone: true}" type="text"
              class="form-control form-control-sm" id="descricao">
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-md-6">
            <label for="unidade">Valor Transferido<span class="text-danger">*</span></label>
            <input [(ngModel)]="entidade.valor_transferencia" [ngModelOptions]="{standalone: true}" type="text"
              class="form-control form-control-sm" unmask="true" [imask]="imaskConfig" id="valor_transferencia"
              placeholder="0,00">
          </div>
          <div class="form-group col-md-6">
            <label for="unidade">Valor Contra Partida<span class="text-danger">*</span></label>
            <input [(ngModel)]="entidade.valor_contrapartida" [ngModelOptions]="{standalone: true}" type="text"
              class="form-control form-control-sm" unmask="true" [imask]="imaskConfig" id="valor_contrapartida"
              placeholder="0,00">
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-md-6">
            <label for="unidade">Valor Total<span class="text-danger">*</span></label>
            <input [(ngModel)]="entidade.valor_total" [ngModelOptions]="{standalone: true}" type="text"
              class="form-control form-control-sm" unmask="true" [imask]="imaskConfig" id="valor_total"
              placeholder="0,00">
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button (click)="salvar()" type="button" class="btn btn-secondary" id="btnSalvar">Salvar</button>
        <button type="button" class="btn btn-link" id="btnCancelar" data-dismiss="modal">Cancelar</button>
      </div>
    </div>
  </div>
</div>